export default __webpack_public_path__ + "static/891-ff502b0fab7ef43b15568137f404a028.gif";